import { HttpClient } from '@angular/common/http';
import {environment} from 'src/environments/environment';
import {inject, Injectable} from '@angular/core';
import {sId} from 'src/app/shared/interfaces/api.interfaces';
import {Observable} from 'rxjs';

const base_url = environment.base_url;

@Injectable({
  providedIn: 'root',
})
export class PointOfSaleService {
  private http = inject(HttpClient);

  constructor() {
  }

  generateCufd(pointOfSaleId: sId): Observable<{
    message: string;
    cufd: string;
    controlCode: string;
    expireCufd: string;
    createdAt: string;
  }> {
    const url = `${base_url}/pointOfSale/generateCufd`;
    return this.http.post<{
      message: string;
      cufd: string;
      controlCode: string;
      expireCufd: string;
      createdAt: string;
    }>(url, {
      pointOfSaleId,
    });
  }

  generateCuisByAdmin(companyId: string): Observable<{
    message: string;
  }> {
    const url = `${base_url}/pointOfSale/generateCuisByAdmin`;

    return this.http.put<{ message: string }>(url, {
      companyId: companyId
    });
  }
}
